import React, {useState} from 'react';
import {View, ScrollView} from 'react-native';
import {Divider} from 'react-native-paper';
import moment from 'moment';

import sy from '~/styles';
import {Text, Link, Modal, Pressable, Dialog} from '~/components/controls';
import {Grouping} from '~/components/controls/3';
import Format from '~/lib/format';

import ChevronLeftIcon from '~/images/md-icons/chevron_left/materialicons/24px.svg';
import HistoryIcon from '~/images/md-icons/history/materialicons/24px.svg';
import ServiceHistory from './ServiceHistory';
import RobServiceHistory from './RobServiceHistory';
import PropTypes from 'prop-types';

import LogoIcon from '~/images/app_icon.svg';
import RobLogoIcon from '~/images/rob-logo.svg';

const ServiceHistoryLink = ({request_id, license, history, dealer_id}) => {
  const [showModal, setShowModal] = useState(false);
  const [showInfoDialog, setShowInfoDialog] = useState(false);

  const onDismiss = () => {
    setShowModal(false);
  };

  if (!history?.length) {
    return <Text>Geen gegevens</Text>;
  }

  return (
    <>
      <Link onPress={() => setShowModal(true)}>
        {moment(history[0].date).format('D-M-YYYY')}&nbsp;(
        {history[0].rob_code ??
          `${Format.number(
            moment().diff(moment(history[0].date), 'months') / 12,
            1,
            true,
            {
              minimumFractionDigits: 0,
            },
          )} jaar`}
        )
      </Link>
      <Modal visible={showModal} onDismiss={onDismiss}>
        <View
          style={[
            {height: 64},
            sy['flex-row'],
            sy['items-center'],
            sy['gap-8'],
          ]}>
          <Pressable style={[sy['p-4']]} onPress={onDismiss}>
            <ChevronLeftIcon fill="#4a4a49" />
          </Pressable>
          <View
            style={[sy['flex-1'], sy['items-center'], sy['justify-center']]}>
            <Text style={sy.smallPlus}>Historie</Text>
          </View>
          <Pressable
            style={[sy['p-4']]}
            onPress={() => setShowInfoDialog(true)}>
            <HistoryIcon fill="#4a4a49" />
          </Pressable>
        </View>
        <Divider style={sy['bg-gray88']} />
        <ScrollView
          style={[sy['bg-gray95']]}
          contentContainerStyle={[sy['p-2'], sy['gap-2']]}>
          {history.map((item, index) => {
            const historyKey = `${item.service_request_id ?? 'rob'}-${
              item.rob_code ?? item.date
            }`;

            let Content;

            if (item.rob_code) {
              Content = (
                <View style={sy['p-4']}>
                  <Text>Laatst bekende onderhoudsbeurt in ROB-Net</Text>
                </View>
              );
            } else if (item.is_rob) {
              Content = <RobServiceHistory {...item} />;
            } else {
              Content = (
                <ServiceHistory
                  request_id={request_id}
                  license={license}
                  history_service_request_id={item.service_request_id}
                  dealer_id={dealer_id}
                />
              );
            }

            return (
              <Grouping
                header={
                  <>
                    {moment(item.date).format('D-M-YYYY')}&nbsp;&middot;&nbsp;
                    {item.rob_code ??
                      `${Format.number(item.kilometrage, 0, true)} km`}
                  </>
                }
                key={historyKey}
                initial={{expand: index === 0}}
                icon={
                  item.rob_code || item.is_rob ? (
                    <View
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: 12,
                        borderWidth: 1,
                        borderColor: '#DCDCDC',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                      <RobLogoIcon width={17} />
                    </View>
                  ) : (
                    <View
                      style={{
                        width: 24,
                        height: 24,
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                      <LogoIcon width={18} height={17} />
                    </View>
                  )
                }>
                {Content}
              </Grouping>
            );
          })}
        </ScrollView>
      </Modal>
      <Dialog
        title={
          <View
            style={[sy['flex-row'], sy['items-center'], sy['justify-between']]}>
            <Text style={sy.largePlus}>Beschikbare historie</Text>
          </View>
        }
        titleIcon={<HistoryIcon fill="#4a4a49" />}
        visible={showInfoDialog}
        onDismiss={() => setShowInfoDialog(false)}>
        <View style={[sy['py-4']]}>
          <Text>
            Hier wordt per datum en kilometerstand de beschikbare historie voor
            dit kenteken weergegeven.
          </Text>
        </View>
      </Dialog>
    </>
  );
};
ServiceHistoryLink.propTypes = {
  request_id: PropTypes.any,
  license: PropTypes.any,
  history: PropTypes.any,
};

export default ServiceHistoryLink;
